import { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useDetalleSolicitudModel } from '../../../modelos/Solicitudes/modeloSolicitud'; // Ajusta según tu estructura
import { useUsers } from '../../../metodos/userContext';
import { formatearFechaCompleta, formatearPrecio} from '../../../utils/utils'; // Importamos desde el archivo utils.js
import { 
  Edit3, 
  AlertTriangle,
  DollarSign, 
  Bell, 
  Eye, 
  FileText,
  AlertCircle,
  Clock,
  User,
  Info,
} from 'lucide-react';
import ConfirmationDialog from '../../../utils/confirmacionDialog'; // Asegúrate de crear este componente
import EditableField from '../../../components/EditableFields';
import { useFormOptions } from '../../.././config/constants';
import DescripcionActividadSolicitud from './components/infoSolicitudes';
import { useListasModel } from '../../../modelos/listas/modeloListas';
import ModalCotizar from '../../../views/tutorRoute/tutorCotizar';
import PreguntasComponent from './Modulos/Preguntas';
import ModalServicioAgendado from '../../../views/adminRoute/Solicitudes/Agendas/ModalTrabajoAgendado';
import { useConfiguracion } from '../../../metodos/ConfiguracionContext';
import useClientesModel from '../../../modelos/Clientes/modeloClientes';
import Cotizaciones from './Modulos/Cotizaciones';
import ModalAgendarTrabajo from '../../../views/adminRoute/Solicitudes/Agendas/ModalAgendarTrabajo';
import { useisUserAdmin, useNombreEmpresaReal } from '../../../config/unificacion';
import BooleanField from '../../../components/BooleanField';
import ModalCopiarSolicitud from './Modulos/CopiarSolicitud';
import NotificacionSolicitudes from './Modulos/Notificaciones_solicitudes';
import VistaSolicitudes from './Modulos/Vistas_solicitudes';
import ModuloHistorial from '../../../components/Historial/Historial';
import { BotonVolver } from '../../../utils/navigator';

const DetallesSolicitudes = () => {
  console.log("detalles solicitudes");
  // Obtener parámetros de la URL
  const {nombreEmpresa, idSolicitud } = useParams();
  const [showModalAgendar, setShowModalAgendar] = useState(false);
  const [cotizacionSeleccionada, setCotizacionSeleccionada] = useState(null);

  //edicion
  const [activeTab, setActiveTab] = useState('general');
  let nombreEmpresaReal = useNombreEmpresaReal(nombreEmpresa);
  const {usuario} = useUsers();
  const isAdmin = useisUserAdmin(usuario);

  const navigate = useNavigate();
  const [showModalCotizar, setShowModalCotizar] = useState(false);
  const [haCotizado, setHaCotizado] = useState(false);
  const [cotizacionUsuario, setCotizacionUsuario] = useState(null);
  const {tipoServiciosListAdmin , estadoSolicitudVisibles , } = useFormOptions();
  
  const [showModalExito, setShowModalExito] = useState(false);
  const [servicioDataRetornado, setServicioDataRetornado] = useState(null);

  //modal copia servicios
  const [showModalCopia, setShowModalCopia] = useState(false);

  const {
    materiasOptions,
    cargarMaterias,
  } = useListasModel();

  const { 
    configuracion, 
  } = useConfiguracion();

  const {
    cliente,
    getCliente,
    busquedaClientesOptions,
    handleInputChange,
    loadingClientes
  } = useClientesModel();

  // Estados
  const [tab, setTab] = useState('descripcion');

  const {
    addNewSolicitud,
    solicitud,
    nuevaCotizacion,
    loadingSolicitudes,
    errorSolicitudes,
    cargarSolicitudPorId,
    handleInputChangeCotizacion,
    addNewCotizacion,
    setupWebSocketsSolicitudes,
    rechazarSolicitud,
    actualizarSolicitud,
    deleteCotizacion,
    confirmDialog, 
    closeConfirmDialog ,
  } = useDetalleSolicitudModel();

  const location = useLocation();

  //Agregar control de ejecuciones
  const hasViewedRef = useRef(false);
  const isLoadingRef = useRef(false);

  //cargar materias
  useEffect(() => {
    console.log("cargar materias");
    cargarMaterias();
    }, []);

  // cargando solicitud
  useEffect(() => {
    if (!idSolicitud || !nombreEmpresaReal || isLoadingRef.current) return;
    
    console.log("cargando solicitud");
    isLoadingRef.current = true;
    
    const cargarYConfigurarSolicitud = async () => {
      try {
        // Cargar la solicitud
        const solicitudObjeto = await cargarSolicitudPorId(idSolicitud, nombreEmpresaReal);
        console.log("solicitud es", solicitudObjeto);
        
        // Configurar WebSockets
        const cleanupWebSockets = setupWebSocketsSolicitudes(solicitudObjeto, nombreEmpresaReal);
        
        return cleanupWebSockets;
      } catch (error) {
        console.error("Error cargando solicitud:", error);
      } finally {
        isLoadingRef.current = false;
      }
    };
    
    const cleanup = cargarYConfigurarSolicitud();
    
    return () => {
      cleanup.then(cleanupFn => cleanupFn && cleanupFn());
    };
  }, [idSolicitud, nombreEmpresaReal]);

  //cotizaciones, vista de tutor y cargar cliente
  useEffect(() => {
  if (!solicitud || !usuario) return;
  
  const procesarSolicitudYUsuario = async () => {
    // 1. Verificar cotizaciones (solo para tutores)
    if (usuario.rol === "TUTOR" && solicitud.cotizaciones) {
      const cotizacion = solicitud.cotizaciones.find(
        cot => cot.nombretutor === usuario.nombrewhatsapp
      );
      
      if (cotizacion) {
        setHaCotizado(true);
        setCotizacionUsuario(cotizacion);
      } else {
        setHaCotizado(false);
        setCotizacionUsuario(null);
      }
    }
    
    // 2. Verificar si ya vio la solicitud (solo para tutores y una sola vez)
    if (usuario.rol === "TUTOR" && solicitud.tutorVistaSolicitud && !hasViewedRef.current) {
      const vista = solicitud.tutorVistaSolicitud.find(
        vistatutor => vistatutor.nombreTutor === usuario.nombrewhatsapp
      );
      
      if (vista) {
        console.log("ya lo vio");
        hasViewedRef.current = true;
      } else {
        console.log("no lo ha visto");
        console.log("el usuario cargado", usuario);
        
        // Marcar como visto antes de hacer la actualización
        hasViewedRef.current = true;
        
        const updateData = {
          'nombreTutor': usuario.nombrewhatsapp,
          'fechaConfirmacion': new Date(),
        };
        
        try {
          await actualizarSolicitud(
            solicitud.id,
            nombreEmpresaReal,
            'tutorVistaSolicitud',
            updateData,
            'array_insert'
          );
        } catch (error) {
          console.error("Error actualizando vista del tutor:", error);
          // Resetear en caso de error
          hasViewedRef.current = false;
        }
      }
    }
    
    // 3. Cargar cliente si existe
    if (solicitud.cliente) {
      try {
        //vamos a buscar el cliente, dependiendo de quien sea el referido
        const empresaReferida = solicitud.referidoPor;
        let empresaBusquedaCliente = '';
        if(empresaReferida == ""){
          empresaBusquedaCliente = nombreEmpresaReal;
        } 
        else{
          if (nombreEmpresa === 'DUFY_ASESORIAS') {
            empresaBusquedaCliente = empresaReferida.replace(/_/g, ' ');
          }else{
            empresaBusquedaCliente = empresaReferida;
          }
        }
        
        const clienteCargado = await getCliente(empresaBusquedaCliente, solicitud.cliente);
        console.log("Cliente cargado:", clienteCargado);
      } catch (error) {
        console.error("Error cargando cliente:", error);
      }
    }
  };
  
  procesarSolicitudYUsuario();
}, [solicitud, usuario, nombreEmpresaReal]);

  //limpiar refs cuando el componente se desmonte
  useEffect(() => {
  return () => {
    hasViewedRef.current = false;
    isLoadingRef.current = false;
  };
  }, [idSolicitud, usuario?.nombrewhatsapp]);

  const handleCloseModal = useCallback(() => {
    setShowModalCotizar(false);
  }, []);

  // Función para volver atrás
  const handleRegresar = () => {
    if (location.key !== 'default') {
      navigate(-1); 
    } else {
      navigate('/dashboard'); 
    }
  };

  const addNewCotizacionLocal = useCallback(async (e) => {
    e.preventDefault();
    try {
      await addNewCotizacion(nombreEmpresaReal);
      setShowModalCotizar(false);
    } catch (error) {
      console.error("Error al enviar cotización:", error);
    }
  }, [addNewCotizacion, nombreEmpresaReal]);

  //Eliminar cotizacion
  const deleteCotizacionLocal = async(cotizacion) =>{
    console.log("eliminar cotizacion",cotizacion);
    deleteCotizacion(nombreEmpresaReal,solicitud.id,cotizacion);
  
  }

  //Agendar trabajo
  const agendarTrabajo = async(cotizacion) => {
    setCotizacionSeleccionada(cotizacion);
    setShowModalAgendar(true);
  }

  const handleSave = async (field, value) => {

    console.log("actualizar cosas",field,value);

    await actualizarSolicitud(solicitud.id,nombreEmpresaReal,field,value,'field')
  
  }

  //manejo de preguntas, agregando preguntas existentes a la pregunta, lo mejor
  const handleEnviarPregunta = async (preguntasActualizadas) => {
    await actualizarSolicitud(solicitud.id, nombreEmpresaReal, 'preguntas', preguntasActualizadas, 'field');

  };

  const auxiliarBusqueda = (field, selectedOption, inputValue) => {
    console.log("auxiliar busqueda",field,selectedOption,inputValue);
    handleInputChange(selectedOption);
  }

  const AdminPreguntasTab = () => {
    return (
      <div className="space-y-4">
        <PreguntasComponent
          preguntas={solicitud.preguntas || []}
          usuarioActual={usuario}
          isAdmin={isAdmin}
          onEnviarPregunta={handleEnviarPregunta}
          onResponderPregunta={handleEnviarPregunta}
        />
      </div>
    );
  };
  
  const AdminGeneralTab = () => {

    return(
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

          <EditableField
            field="Servicio"
            label="Tipo de Servicio"
            value={solicitud.Servicio}
            type="react-select"
            options={tipoServiciosListAdmin}
            isAdmin={isAdmin}
            onSave={handleSave}
          />

          <EditableField
            field="materia"
            label="Materia"
            value={solicitud.materia}
            type="react-select"
            options={materiasOptions}
            isAdmin={isAdmin}
            onSave={handleSave}
            placeholder="Ingrese la materia"
          />

          <EditableField
            field="fechaentrega"
            label="Fecha de entrega"
            value={solicitud.fechaentrega}
            type="datetime"
            isAdmin={isAdmin}
            onSave={handleSave}
            placeholder="Ingrese la fecha"
          />  
          
          <EditableField
            label="Id Solicitud"
            value={solicitud.id}
            type="text"
            isAdmin={false}
            onSave={handleSave}
          />
        
        {/* Clientes options */}
          <EditableField
            field="cliente"
            label="Numero del cliente"
            value={solicitud.cliente}
            onInputChange={auxiliarBusqueda} // Búsqueda en tiempo real
            type="react-select"
            options={busquedaClientesOptions}
            isAdmin={isAdmin} //cliente, hay que permitir cambio
            onSave={handleSave}
          />

          <EditableField
            label="Fecha de sistema"
            value={solicitud.fechasistema}
            type="datetime"
            isAdmin={false}
            onSave={handleSave}
          />  

          <EditableField
            field="Estado"
            label="Estado"
            value={solicitud.Estado}
            type="react-select"
            options={estadoSolicitudVisibles}
            isAdmin={isAdmin}
            onSave={handleSave}
          />

          {/* COSAS POR IA */}
          <EditableField
            field="predicionesIA.carreraIa"
            label="Carrera IA"
            value={solicitud?.predicionesIA?.carreraIa}
            type="text"
            isAdmin={false}
          />

          <EditableField
            field="predicionesIA.carreraSugerencia"
            label="Carrera Sugerencia"
            value={solicitud?.predicionesIA?.carreraSugerencia}
            type="text"
            isAdmin={false}
          />

          <EditableField
            field="predicionesIA.materiaIA"
            label="Materia IA"
            value={solicitud?.predicionesIA?.materiaIA}
            type="text"
            isAdmin={false}
          />

          <EditableField
            field="predicionesIA.materiaSugerencia"
            label="Materia Sugerencia"
            value={solicitud?.predicionesIA?.materiaSugerencia}
            type="text"
            isAdmin={false}
          />

          
          { solicitud.esProPlataforma() && (
          <div className="md:col-span-2 mt-4 p-4 border-l-4 border-blue-500 bg-slate-50 rounded-r-lg">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Detalles de ProPlataforma</h3>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              <EditableField
                field="proPlataforma.materia"
                label="Materia Asignada"
                value={solicitud.proPlataforma?.materia}
                type="text"
                isAdmin={isAdmin}
                onSave={handleSave}
              />

              <EditableField
                field="proPlataforma.fase"
                label="Fase"
                value={solicitud.proPlataforma?.fase}
                type="text"
                isAdmin={isAdmin}
                onSave={handleSave}
              />

              <EditableField
                field="proPlataforma.plataforma"
                label="Plataforma"
                value={solicitud.proPlataforma?.plataforma}
                type="text"
                isAdmin={isAdmin}
                onSave={handleSave}
              />

              <BooleanField
                field="proPlataforma.manejoPlataforma"
                label="Manejo de plataforma nosotros"
                value={solicitud.proPlataforma.manejoPlataforma}
                isAdmin={true}
                displayAs='toggle'
                onSave={handleSave}
              />

              <EditableField
                field="proPlataforma.semestre"
                label="Semestre"
                value={solicitud.proPlataforma?.semestre}
                type="text"
                isAdmin={isAdmin}
                onSave={handleSave}
              />

              <EditableField
                field="proPlataforma.fechaRealUnad"
                label="Fecha Real UNAD"
                value={solicitud.proPlataforma?.fechaRealUnad}
                type="date"
                isAdmin={isAdmin}
                onSave={handleSave}
              />

              <BooleanField
                field="proPlataforma.esColaborativo"
                label="Es colaborativo?"
                value={solicitud.proPlataforma.esColaborativo}
                isAdmin={true}
                displayAs='toggle'
                onSave={handleSave}
              />

              <BooleanField
                field="proPlataforma.tieneForo"
                label="Tiene foro?"
                value={solicitud.proPlataforma.tieneForo}
                isAdmin={true}
                displayAs='toggle'
                onSave={handleSave}
              />



            </div>
          </div>
        )}
          

        </div>
      
        <div className="bg-white p-4 rounded-lg border">

          <DescripcionActividadSolicitud 
            key={solicitud.ultimaModificacion} 
            solicitud={solicitud}
            isAdmin = {true}
            onUpdateSolicitud = {handleSave}
            />
          
          <p className="text-sm text-gray-600 mt-2">{solicitud.formato}</p>
        </div>
    </div>
    );
  }
    
  const AdminCotizacionesTab = useCallback(() => {
    return <Cotizaciones
      solicitud={solicitud}
      deleteCotizacionLocal={deleteCotizacionLocal}
      cliente={cliente}
      addNewCotizacion={addNewCotizacion}
      configuracion={configuracion}
      onAgendarTrabajo={agendarTrabajo}
    />
  }, [solicitud, deleteCotizacionLocal, cliente, addNewCotizacion, configuracion, agendarTrabajo]);

  const AdminNotificacionesTab = () => (
      <NotificacionSolicitudes
        solicitud={solicitud}
      />
  );

  const AdminVistasTab = () => (
    <VistaSolicitudes
      solicitud={solicitud}
    />
  );

  const AdminHistorialTab = () => {
    console.log("historial de solciitudes",solicitud.historial);
    return (
      <ModuloHistorial
        historial={solicitud.historial}
    />    
    );
    
  };
  
  const adminTabs = [
    { id: 'general', 
      label: 'General', 
      icon: FileText ,
    },
    { 
    id: 'cotizaciones', 
    label: 'Cotizaciones', 
    icon: DollarSign,
    count: solicitud?.cotizaciones?.filter(cot => cot.cotizacion > 0).length || 0
    },    
    { id: 'notificaciones', label: 'Notificaciones', icon: Bell },
    { id: 'vistas', label: 'Vistas', icon: Eye , count: solicitud?.tutorVistaSolicitud?.length || 0 },
    { id: 'historial', label: 'Historial', icon: Eye  },
    { 
    id: 'preguntas', 
    label: 'preguntas', 
    icon: DollarSign,
    count: solicitud?.preguntas.filter(pregunta => 
      !pregunta.respuesta || 
      pregunta.respuesta.length === 0
    ).length || 0 //sin respuesta responder ugentemente
    }, 

  ];
  const TutorView = () => (
  <div className="space-y-6">
    {/* Navegación de tabs */}
    <div className="border-b border-gray-200 mb-4">
      <div className="flex">
        <button 
          className={`py-2 px-4 border-b-2 ${tab === 'descripcion' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500'} font-medium`}
          onClick={() => setTab('descripcion')}
        >
          Descripción
        </button>
        <button 
          className={`py-2 px-4 border-b-2 ${tab === 'preguntas' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500'} font-medium`}
          onClick={() => setTab('preguntas')}
        >
          Preguntas
        </button>
      </div>
    </div>

    {/* Contenido de los tabs - FUERA de los botones */}
    <div className="mb-6">
      
      {/* Descripcion */}
      {tab === 'descripcion' && (
        <div className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

            <div className="bg-gray-50 p-3 rounded-lg">
              <label className="text-sm text-gray-600 block mb-1">Tipo de Servicio</label>
              <span className="font-medium text-gray-800">{solicitud.Servicio || 'No especificado'}</span>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg">
              <label className="text-sm text-gray-600 block mb-1">Materia</label>
              <span className="font-medium text-gray-800">{solicitud.materia || 'No especificada'}</span>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg">
              <label className="text-sm text-gray-600 block mb-1">Fecha de Entrega</label>
              <span className="font-medium text-gray-800">
                {formatearFechaCompleta(solicitud.fechaentrega)}
              </span>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg">
              <label className="text-sm text-gray-600 block mb-1">Id Solicitud</label>
              <span className="font-medium text-green-600">{solicitud.id}</span>
            </div>

            {/* PRO PLATAFORMA. */}
            {solicitud.esProPlataforma() && (
              <div className="md:col-span-2 mt-4 p-4 border-l-4 border-blue-500 bg-slate-50 rounded-r-lg">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">Detalles de ProPlataforma</h3>
                
                {/* --- Parrilla para los campos de la plataforma --- */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  <EditableField
                    field="proPlataforma.materia"
                    label="Materia"
                    value={solicitud.proPlataforma?.materia}
                    type="text"
                    isAdmin={isAdmin}
                    onSave={handleSave}
                  />
                  <EditableField
                    field="proPlataforma.fase"
                    label="Fase"
                    value={solicitud.proPlataforma?.fase}
                    type="text"
                    isAdmin={isAdmin}
                    onSave={handleSave}
                  />
                  <EditableField
                    field="proPlataforma.plataforma"
                    label="Plataforma"
                    value={solicitud.proPlataforma?.plataforma}
                    type="text"
                    isAdmin={isAdmin}
                    onSave={handleSave}
                  />
                </div> {/* <-- SE CIERRA LA PARRILLA DE CAMPOS AQUÍ */}

                {/* --- Panel informativo de la UNAD (AHORA FUERA DE LA PARRILLA) --- */}
                {/* Se muestra solo si 'manejoPlataforma' es true */}
              
                {solicitud.proPlataforma?.manejoPlataforma && (
                  <div className="mt-6">
                    {/* === DISEÑO DE ALERTA COMPACTA === */}
                    <div className="bg-rose-50 border-l-4 border-red-500 rounded-r-lg p-4 shadow-md font-sans">
                      <div className="flex">
                        
                        {/* Columna del Ícono */}
                        <div className="py-1">
                          <AlertTriangle className="h-6 w-6 text-red-500" />
                        </div>

                        {/* Columna del Contenido */}
                        <div className="ml-3">
                          <p className="font-bold text-base text-red-900">
                            Manejo de Plataforma Especial (UNAD)
                          </p>
                          <div className="text-sm text-red-700 mt-2 space-y-1">
                            <p>
                              Se requiere gestión completa de la plataforma, incluyendo: <strong>Foros, trabajos (colaborativos y normales), y videos.</strong>
                            </p>
                            <p className="font-semibold">
                              Es obligatorio evitar el plagio y el uso indiscriminado de IA.
                            </p>
                            <p className="text-xs italic mt-2 text-red-600">
                              Las credenciales de acceso se mostrarán aquí una vez el servicio sea agendado.
                            </p>
                          </div>
                        </div>
                        
                      </div>
                    </div>
                  </div>
                )}
                
              </div>
            )}
          </div>

          {solicitud.cliente}

          <DescripcionActividadSolicitud 
          solicitud={solicitud}
          initialTab="descripcion" // Opcional, por defecto es 'descripcion'
          />

        {/* Información de cotización */}
        <div className="bg-blue-50 p-4 rounded-lg mb-6">
          <h3 className="font-semibold text-blue-800 mb-2">Información para cotizar</h3>
          <p className="text-blue-700 text-sm mb-2">
            Este {solicitud.Servicio} requiere un tutor con experiencia en la materia {solicitud.materia || 'el área solicitada'}.
            Solicitado por {solicitud.nombreEmpresa}
          </p>
          <p className="text-sm text-blue-800 font-medium">
            Cotiza ahora para tener la oportunidad de obtener la agenda.
          </p>
        </div>
        
        {haCotizado ? (
        <>
          {cotizacionUsuario?.cotizacion === -1 ? (
            // Visualización para solicitudes rechazadas
            <div className="bg-red-50 border border-red-200 rounded-md p-4 w-full text-center">
              <p className="text-red-700 font-medium">
                Has rechazado esta solicitud
              </p>
              <p className="text-sm text-red-600 mt-1">
                Rechazada el {formatearFechaCompleta(cotizacionUsuario.fechaconfirmacion)}
              </p>

              

            </div>
          ) : (
            // Visualización para solicitudes cotizadas normalmente
            <div className="bg-green-50 border border-green-200 rounded-md p-4 w-full text-center">
              <p className="text-green-700 font-medium">
                Has cotizado esta solicitud por {formatearPrecio(cotizacionUsuario?.cotizacion)}
              </p>
              <p className="text-sm text-green-600 mt-1">
                Enviada el {formatearFechaCompleta(cotizacionUsuario?.fechaconfirmacion)}
              </p>
              {/* === AVISO PARA CAMBIAR PRECIO === */}
              <div className="mt-4 pt-4 border-t border-green-200 text-left">
                <div className="flex items-start gap-3 p-3 bg-yellow-50 rounded-md border border-yellow-200">
                  {/* Asegúrate de importar el ícono 'AlertCircle' de lucide-react */}
                  <AlertCircle size={20} className="text-yellow-600 flex-shrink-0 mt-0.5" />
                  <div>
                    <h4 className="font-bold text-yellow-800 text-sm">Aviso Importante</h4>
                    <p className="text-yellow-700 text-xs mt-1">
                      Una vez cotizado, el precio no puede ser modificado desde esta pantalla. Si cometiste un error o necesitas <strong>cambiar el valor, por favor escríbenos</strong> para realizar el ajuste.
                    </p>
                  </div>
                </div>
              </div>

            </div>
          )}
        </>
        ) : (
          <>
            <button
              onClick={() => rechazarSolicitud(nombreEmpresaReal)}
              className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
            >
              Rechazar
            </button>
            
            <button
              type="submit"
              onClick={() => setShowModalCotizar(true)}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md shadow-sm text-sm font-medium focus:outline-none"
            >
              Cotizar Proyecto
            </button>
          </>
        )}
      
        </div>
      )}

      {/* Preguntas */}
      {tab === 'preguntas' && (
        <AdminPreguntasTab />
      )}

    </div>
  </div>
  );

  // Si está cargando, mostrar indicador de carga
  if (loadingSolicitudes) {
    return (
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-4xl mx-auto flex flex-col items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mb-4"></div>
        <p className="text-gray-600">Cargando detalles de la solicitud...</p>
      </div>
    );
  }
  
  // Si hay error o no hay solicitud, mostrar mensaje de error
  if (errorSolicitudes || !solicitud) {
    return (
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-4xl mx-auto">
        <div className="text-center">
          <div className="bg-red-100 text-red-800 p-4 rounded-lg mb-6">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto mb-2 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h2 className="text-xl font-bold mb-2">Error al cargar la solicitud</h2>
            <p className="mb-4">No se ha podido cargar la información de esta solicitud. Puede que haya sido eliminada o no tengas acceso a ella.</p>
          </div>
          
          <button 
            onClick={handleRegresar} 
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded transition-colors duration-300"
          >
            Volver a la lista de solicitudes
          </button>
        </div>
      </div>
    );
  }
    
  //solo los ADMINS pueden ver lo que sea, sin importar que
  if(solicitud.Estado && !isAdmin){
    const estadosNoDisponibles = ["EXPIRADO", "NO PODEMOS", "AGENDADO"];

    if (estadosNoDisponibles.includes(solicitud.Estado)) {
      return (
        <div className="p-4">
          <div className="bg-red-50 border border-red-200 rounded-md p-4 mb-4 flex items-center">
            <AlertCircle className="text-red-500 mr-2" size={20} />
            <div>
              <p className="text-red-700 font-medium">
                Esta solicitud no está disponible
              </p>
              <p className="text-red-600 text-sm">
                Estado actual: No Disponible {solicitud.id}
              </p>
            </div>
          </div>
          
          <BotonVolver
            ruta='/dashboard'
          />

        </div>
      );
    }
  }

  // ✅ CALLBACK PARA RECIBIR DATOS
  const handleServicioAgendado = (datosServicio) => {
    console.log("✅ Servicio agendado recibido:", datosServicio);
    setServicioDataRetornado(datosServicio);
    console.log("servicio data",servicioDataRetornado);
    setShowModalExito(true);
  };

  //copiar solicitud
  const copiarSolicitud = async(numeroTelefono) =>{
    console.log("Copiar solicitud al número:", numeroTelefono);

    const solicitudCopia = { ...solicitud };
    solicitudCopia.cliente = numeroTelefono;
    delete solicitudCopia.historial;

    //añadir solicitud copiada
    try{
      const nombreEmpresaSubida = configuracion?.servicios_empresas?.[solicitudCopia.Servicio];
      await addNewSolicitud(nombreEmpresaSubida,solicitudCopia);
      setShowModalCopia(false);
    }
    catch(error){
      console.error("Error al copiar la solicitud",error);
    }
    

  }

  // Renderizar la vista detallada normal si todo está bien
  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden max-w-4xl mx-auto">

      <ModalServicioAgendado
        servicioDataRetornado={servicioDataRetornado}
        isOpen={showModalExito}
        onClose={() => setShowModalExito(false)}
        configuracion={configuracion}
        clienteData={cliente}
      />

      {/* ✅ AGREGAR MODAL PARA AGENDAR TRABAJO */}
      {showModalAgendar && (
        <ModalAgendarTrabajo
          showModal={true} // Siempre true cuando está montado
          onClose={() => setShowModalAgendar(false)}
          cotizacion={cotizacionSeleccionada}
          solicitud={solicitud}
          cliente={cliente}
          onServicioAgendado={handleServicioAgendado}
        />
      )}

      {/* Modal para cotizar solicitudes */}
      <ModalCotizar
        showModal={showModalCotizar}
        onClose={handleCloseModal}
        nuevaCotizacion={nuevaCotizacion}
        onInputChange={handleInputChangeCotizacion}
        onSubmit={addNewCotizacionLocal}
        servicioDataRetornado={servicioDataRetornado}
      />

      {/* Modal para rechazar confirmaciones */}
      <ConfirmationDialog 
        isOpen={confirmDialog.isOpen}
        message={confirmDialog.message}
        onConfirm={confirmDialog.onConfirm}
        onCancel={closeConfirmDialog}
      />

      {/* Modal para copiar solicitud */}
      <ModalCopiarSolicitud
        isOpen={showModalCopia}
        onClose={() => setShowModalCopia(false)}
        onCopy={(numeroTelefono) => {
          copiarSolicitud(numeroTelefono);
        }}
        // isCopying={true} // Opcional: pasar un estado de carga si la operación es asíncrona
      />

      {/* Contenido Principal */}
      <div className="bg-gray-100 p-4 flex justify-between items-center">
        <div className="flex space-x-3 items-center">

          <button 
            onClick={handleRegresar}
            className="flex items-center text-gray-600 hover:text-gray-900 bg-gray-50 hover:bg-gray-100 px-4 py-2 rounded-md transition-colors font-medium border border-gray-200 hover:border-gray-300"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Volver
          </button>
          
          <div className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-semibold">
            {solicitud.Servicio}
          </div>
          <div className="text-sm text-gray-500">ID: {solicitud.id}</div>
          <div className={`px-2 py-1 rounded-full text-xs font-medium ${
            isAdmin 
              ? 'bg-blue-100 text-blue-800' 
              : 'bg-green-100 text-green-800'
          }`}>
            {isAdmin ? 'Modo Administrador' : 'Modo Tutor'}
          </div>

          {/* Copiar solicitud */}
          {isAdmin && (
            <button
              onClick={() => setShowModalCopia(true)}
              className="flex items-center gap-2 px-4 py-2 bg-purple-500 text-white rounded-md hover:bg-purple-600 transition-colors"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
              Copiar Solicitud
            </button>
          )}

        </div>
      </div>

      {/* Contenido */}
      <div className="p-6">
          <h1 className="text-2xl font-bold text-gray-800 mb-6">{solicitud.materia}</h1>
          
          {/* Mensaje de estado condicional */}
          {solicitud.Estado === 'AGENDADO' && (
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
              <span className="font-semibold">✓ ESTA SOLICITUD YA SE ENCUENTRA AGENDADA</span>
            </div>
          )}
          
          {(solicitud.Estado === 'EXPIRADO' || solicitud.Estado === 'NO PODEMOS') && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
              <span className="font-semibold">
                {solicitud.estado === 'EXPIRADO' ? '⚠ SOLICITUD EXPIRADA' : '✗ NO PODEMOS REALIZAR ESTA SOLICITUD'}
              </span>
            </div>
          )}


          {isAdmin ? (
             <>
              {/* CSS para ocultar scrollbar */}
              <style jsx>{`
                .scrollbar-hide {
                  -ms-overflow-style: none;
                  scrollbar-width: none;
                }
                .scrollbar-hide::-webkit-scrollbar {
                  display: none;
                }
              `}</style>

              <div className="border-b border-gray-200 mb-6">
                <nav className="flex space-x-1 overflow-x-auto scrollbar-hide pb-1">
                  {adminTabs.map((tab) => (
                    <button
                      key={tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      className={`py-3 px-4 border-b-2 font-medium text-sm flex items-center gap-2 whitespace-nowrap flex-shrink-0 transition-colors ${
                        activeTab === tab.id
                          ? 'border-blue-500 text-blue-600 bg-blue-50'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 hover:bg-gray-50'
                      }`}
                    >
                      <tab.icon size={16} />
                      <span className="hidden sm:inline">{tab.label}</span>
                      <span className="sm:hidden">
                        {tab.id === 'general' ? 'General' : 
                        tab.id === 'cotizaciones' ? 'Cotiz.' : 
                        tab.id === 'notificaciones' ? 'Notif.' : 'Vistas'}
                      </span>
                      {tab.count !== undefined && tab.count > 0 && (
                        <span className={`px-2 py-0.5 text-xs rounded-full font-medium ${
                          tab.id === 'cotizaciones' 
                            ? (activeTab === tab.id ? 'bg-green-100 text-green-700' : 'bg-green-50 text-green-600')
                            : tab.id === 'vistas'
                            ? (activeTab === tab.id ? 'bg-blue-100 text-blue-700' : 'bg-blue-50 text-blue-600')
                            : tab.id === 'notificaciones'
                            ? (activeTab === tab.id ? 'bg-orange-100 text-orange-700' : 'bg-orange-50 text-orange-600')
                            : (activeTab === tab.id ? 'bg-gray-100 text-gray-700' : 'bg-gray-50 text-gray-600')
                        }`}>
                          {tab.count}
                        </span>
                      )}
                    </button>
                  ))}
                </nav>
              </div>

              {/* Contenido de Tabs Admin */}
              {activeTab === 'general' && AdminGeneralTab()}
              {activeTab === 'cotizaciones' && <AdminCotizacionesTab />}
              {activeTab === 'notificaciones' && <AdminNotificacionesTab />}
              {activeTab === 'vistas' && <AdminVistasTab />}
              {activeTab === 'historial' && <AdminHistorialTab />}
              {activeTab === 'preguntas' && <AdminPreguntasTab />}
            </>
          ) : (
          <TutorView />
          )}
      </div>
      
    </div>
  );

};


export default DetallesSolicitudes;